export const GET_RECORD_DISCUSSION_SUMMARY_REQUEST = "GET_RECORD_DISCUSSION_SUMMARY_REQUEST";
export const GET_RECORD_DISCUSSION_SUMMARY_SUCCESS = "GET_RECORD_DISCUSSION_SUMMARY_SUCCESS";
export const GET_RECORD_DISCUSSION_SUMMARY_FAILURE = "GET_RECORD_DISCUSSION_SUMMARY_FAILURE";

export const REFRESH_RECORD_DISCUSSION_SUMMARY_REQUEST = "REFRESH_RECORD_DISCUSSION_SUMMARY_REQUEST";
export const RECORD_DISCUSSION_SUMMARY_FETCH_STARTED = "RECORD_DISCUSSION_SUMMARY_FETCH_STARTED";


export const getRecordDiscussionSummaryRequest = (recordType, recordIds) => ({
    type: GET_RECORD_DISCUSSION_SUMMARY_REQUEST,
    payload: { recordType, recordIds },
});

export const refreshRecordDiscussionSummaryRequest = (recordType, recordId) => ({
    type: REFRESH_RECORD_DISCUSSION_SUMMARY_REQUEST,
    payload: { recordType, recordId },
});


export const recordDiscussionSummaryFetchStarted = (recordType, recordIds) => ({
    type: RECORD_DISCUSSION_SUMMARY_FETCH_STARTED,
    payload: { recordType, recordIds },
});

export const getRecordDiscussionSummarySuccess = (recordType, recordIds, summaries) => ({
    type: GET_RECORD_DISCUSSION_SUMMARY_SUCCESS,
    payload: { recordType, recordIds, summaries },
});

export const getRecordDiscussionSummaryFailure = (recordType, recordIds, error) => ({
    type: GET_RECORD_DISCUSSION_SUMMARY_FAILURE,
    payload: { recordType, recordIds, error },
});
